/**
 * Identification Number formatting with auto-detection:
 * - Malaysian IC: 12 digits only → format as xxxxxx-xx-xxxx
 * - Passport / Birth cert: contains letters or not 12 digits → show as-is (no formatting)
 */

const IC_LENGTH = 12;

/**
 * Returns true if the value looks like a Malaysian IC (exactly 12 digits, with or without hyphens).
 */
export function isIcNumber(value) {
  if (!value || typeof value !== 'string') return false;
  const digits = value.replace(/\D/g, '');
  return digits.length === IC_LENGTH && /^\d+$/.test(digits);
}

/**
 * Format for display: only format when value is 12 digits (IC). Otherwise return as-is (passport/birth cert).
 */
export function formatIdentificationDisplay(value) {
  if (!value || typeof value !== 'string') return value;
  const trimmed = value.trim();
  const digits = trimmed.replace(/\D/g, '');
  if (digits.length === IC_LENGTH && /^\d+$/.test(digits)) {
    return `${digits.slice(0, 6)}-${digits.slice(6, 8)}-${digits.slice(8, 12)}`;
  }
  return trimmed;
}

/**
 * Format while user types (for controlled input):
 * - If input contains only digits (and possibly hyphens) and length <= 12 → format as IC (xxxxxx-xx-xxxx).
 * - If input contains any letter → treat as passport/birth cert, return as-is (no IC formatting).
 */
export function formatIdentificationInput(inputValue) {
  if (inputValue == null || typeof inputValue !== 'string') return '';
  const trimmed = inputValue.trim();
  const digits = trimmed.replace(/\D/g, '');
  const hasLetter = /[A-Za-z]/.test(trimmed);
  if (hasLetter || digits.length > IC_LENGTH) {
    return trimmed;
  }
  if (digits.length === 0) return '';
  if (digits.length <= 6) return digits;
  if (digits.length <= 8) return `${digits.slice(0, 6)}-${digits.slice(6)}`;
  return `${digits.slice(0, 6)}-${digits.slice(6, 8)}-${digits.slice(8, IC_LENGTH)}`;
}
